// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"4e8220fd","260":"acf7da9e","547":"2528861d","615":"3d57cf2e","659":"259d6427","705":"0a7bcd55","731":"02f9218c","825":"93e88e6a","902":"fd8a9b80","974":"cca71152"}[chunkId] + ".chunk.js";
};